import React, { useState } from "react";
import axios from "axios";


const useUser = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getUserSelfData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/home/user_self', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    // const postUserSelfData = (data) => {
    //     onBefore({
    //         axiosMode: "post"
    //     })
    //     axios.post('/system/news',
    //         data
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "post",
    //                     status: "error"
    //                 }
    //             )
    //         })

    // }
    const patchUserSelfData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/home/user_self',
                data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    // const deleteUserSelfData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete('/system/news',
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    return {
        UserSelfData: data,
        getUserSelfData,
        // postUserSelfData,
        patchUserSelfData,
        // deleteUserSelfData,
        
    }
}
export { useUser }
